export default __webpack_public_path__ + "static/media/profile_report_joyride.dba9f0bb.svg";